<div class="page-padding">
  <div class="panel">
    <div class="panel__header">
      <span class="panel__header__title">{{"Advanced Implement Copying" | translate | async}}</span>
    </div>

    <mat-card>
      <div id="flex-container">
        <div class="flex-item">
          <div class="margin-bottom-24">
            <div>
              <h5>{{"Source Details" | translate | async}}</h5>
            </div>
          </div>
          <div class="input-group-description">
            <b>{{"Please select the customer and job site where the EXISTING implement is located" | translate | async}}</b>
          </div>
          <div class="margin-bottom-24">
            <div class="input-container">
              <label for="customer" class="label">{{"Customer" | translate | async}}</label>
              <select id="customer" placeholder="Select Customer" [(ngModel)]="selectedCustomer" class="get-Input"
                (change)="loadJobsitesForCustomer()" ngDefaultControl required>
                <option [value]="customer.Id" *ngFor="let customer of customerList">
                  {{customer.Name}}
                </option>
              </select>
            </div>
            <div class="input-container">
              <label for="jobsite" class="label">{{"Job Site" | translate | async}}</label>
              <select id="jobsite" placeholder="'Select Job Site' | translate | async" [(ngModel)]="selectedJobsite" class="get-Input"
                (change)="loadEquipmentForJobsite()" ngDefaultControl required>
                <option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
                  {{jobsite.Name}}
                </option>
              </select>
            </div>

            <div class="margin-b--16">
              <b>{{"Is the EXISTING implement on an equipment, or in inventory ?" | translate | async}}</b>
            </div>
            <div class="margin-bottom-24">
              <mat-radio-group [(ngModel)]="equipmentOrInventory" ngDefaultControl (change)="createInInventory()">
                <mat-radio-button [value]="1">{{'On Equipment' | translate | async}}</mat-radio-button>
                <mat-radio-button [value]="2">{{'In Inventory' | translate | async}}</mat-radio-button>
                <mat-radio-button [value]="3">{{'Template' | translate | async}}</mat-radio-button>
              </mat-radio-group>
            </div>

            <ng-container *ngIf="equipmentOrInventory==1">
              <div class="input-group-description">
                <b>{{'How do you identify this equipment?' | translate | async}}</b>
              </div>
              <div class="input-container">
                <label for="equipment" class="label">{{"Equipment" | translate | async}}</label>
                <select id="equipment" placeholder="Serial / Unit Number" [(ngModel)]="selectedEquipment"
                  class="get-Input" ngDefaultControl required (change)="onSelectEquipment()">
                  <option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                    {{equipment.SerialNumber}} : {{equipment.UnitNumber}}
                  </option>
                </select>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="flex-item">
          <div class="margin-bottom-24">
            <div>
              <h5>{{"Destination Details" | translate | async}}</h5>
            </div>
          </div>
          <div class="input-group-description">
            <b>{{"Please select the customer and job site where the DESTINATION implement is located" | translate | async}}</b>
          </div>
          <div class="margin-bottom-24">
            <div class="input-container">
              <label for="customer" class="label">{{"Customer" | translate | async}}</label>
              <select placeholder="Select Customer" [(ngModel)]="destinationCustomer" class="get-Input"
                (change)="loadJobsitesForCustomerDestination()" ngDefaultControl required>
                <option [value]="customer.Id" *ngFor="let customer of destinationcustomerList">
                  {{customer.Name}}
                </option>
              </select>
            </div>
            <div class="input-container">
              <label for="jobsite" class="label">{{"Job Site" | translate | async}}</label>
              <select placeholder="Select Job Site" [(ngModel)]="destinationJobsite" class="get-Input"
                (change)="loadEquipmentForJobsiteDestination()" ngDefaultControl required>
                <option [value]="jobsite.Id" *ngFor="let jobsite of destinationjobsiteList">
                  {{jobsite.Name}}
                </option>
              </select>
            </div>

            <div class="margin-b--16">
              <b>{{"Is the DESTINATION implement on an equipment, in inventory or exisiting implement?" | translate | async}}</b>
            </div>
            <div class="margin-bottom-24">
              <mat-radio-group [(ngModel)]="destinationequipmentOrInventory" ngDefaultControl
                (change)="createInInventoryDestination()">
                <mat-radio-button [value]="1">{{'On Equipment' | translate | async}}</mat-radio-button>
                <mat-radio-button [value]="2">{{'In Inventory' | translate | async}}</mat-radio-button>
                <mat-radio-button [value]="3">{{'Existing Implement' | translate | async}}</mat-radio-button>
                <mat-radio-button [value]="4">{{'Template' | translate | async}}</mat-radio-button>


              </mat-radio-group>
            </div>

           

            <ng-container *ngIf="destinationequipmentOrInventory==1">
              <div class="input-group-description">
                <b>{{'How do you identify this equipment?' | translate | async}}</b>
              </div>
              <div class="input-container">
                <label for="equipment" class="label">{{'Equipment' | translate | async}}</label>
                <select placeholder="Serial / Unit Number" [(ngModel)]="destinationEquipment" ngDefaultControl
                  class="get-Input" required (change)="onSelectEquipmentDestinantion()">
                  <option [value]="equipment.Id" *ngFor="let equipment of  destinationequipmentList">
                    {{equipment.SerialNumber}} : {{equipment.UnitNumber}}
                  </option>
                </select>
              </div>
            </ng-container>

            <ng-container *ngIf="destinationequipmentOrInventory==3">

              <div class="input-container">
                <label for="implementType" class="label">{{'Implement Type' | translate | async}}</label>
                <select placeholder="Implement Type" [(ngModel)]="destinationImplementType" ngDefaultControl
                  class="get-Input" required (change)="onSelectImplementTypeDestinantion()">
                  <option [value]="Imptype.Id" *ngFor="let Imptype of  destinationImplementTypsList">
                    {{Imptype.Name}}
                  </option>
                </select>
              </div>
            </ng-container>

            <ng-container *ngIf="destinationequipmentOrInventory==3 ">

              <div class="input-container">
                <label for="implement" class="label">{{'Implement' | translate | async}}</label>
                <select placeholder="Implement" [(ngModel)]="destinationImplement" ngDefaultControl class="get-Input"
                  required>
                  <option [value]="Imp.ImplementId" *ngFor="let Imp of  destinationimplementList">
                    {{Imp.Name}}
                  </option>
                </select>
              </div>
            </ng-container>

            <div class="input-group-description" style="display: none;">
              <b>{{'Selecting Copying of Schematics for Asset' | translate | async}}</b>  <i class="material-icons" style="vertical-align: middle;cursor: pointer;"
               title="The choices allow schematics to be copied to the asset which will allow unique changes to be made for the schematics on that asset. If schematics are not copied (default selection) any changes made at asset level will adjust originating template and all connected assets.">help</i>
            </div>
            <div class="margin-bottom-24" style="display: none;">
              <!-- *ngIf="destinationequipmentOrInventory!=4"-->
              <mat-radio-group [(ngModel)]="IsSchematicUsedLink" ngDefaultControl>
                <mat-radio-button [value]="1">{{'Reference Schematics to Originating Templates' | translate | async}}</mat-radio-button>
                <mat-radio-button [value]="2">{{'Specific Assets' | translate | async}}</mat-radio-button>
              </mat-radio-group>
            </div>
            <div>
              <p>
                <font color="red" *ngIf="!model_match_for_source_desti_eq">{{'The Source Implement is not listed as fitting the Model of the Equipment you have selected,' | translate | async}}
                  <br>{{'however if you wish to proceed it will be added.' | translate | async}}
                </font>
              </p>


            </div>
          </div>
        </div>

      </div>

      <div class="margin-b--16">
        <b>{{"Select Implement(s) to be copied" | translate | async}}</b>
      </div>
      <ng-container>
        <div class="table-container mat-elevation-z8">
          <mat-table [dataSource]="dataSource">

            <ng-container matColumnDef="selectImplement">
              <mat-header-cell *matHeaderCellDef>{{"Select Implement" | translate | async}}</mat-header-cell>
              <mat-cell *matCellDef="let implement">
                <mat-checkbox [(ngModel)]="implement.selectImplement" (click)="CheckImplementSource(implement)"
                  *ngIf="implement.status!=1"></mat-checkbox>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="implementTypeAndSerial">
              <mat-header-cell *matHeaderCellDef>{{"Imp Type:Serial" | translate | async}}</mat-header-cell>
              <mat-cell *matCellDef="let implement">{{implement.implementTypeAndSerial}}</mat-cell>
            </ng-container>

           
            <ng-container matColumnDef="implementType">
              <mat-header-cell *matHeaderCellDef>{{"Implement Type" | translate | async}}</mat-header-cell>
              <mat-cell *matCellDef="let implement">
               
               


                <mat-select  *ngIf="destinationequipmentOrInventory==4 && equipmentOrInventory==3" placeholder="Select Implement Type"  id="implementType_" [(ngModel)]="implement.DestinationTemplateImplementTypeId" name="implementType_" (selectionChange)="ChangeImplementType()">  
                  <mat-option *ngFor="let imp of implementTypeList" [value]="imp.Id">{{imp.Name}}</mat-option>
                  </mat-select>
                  <span *ngIf="destinationequipmentOrInventory!=4 || equipmentOrInventory!=3">N/A</span>
              </mat-cell>

            </ng-container>

            <ng-container matColumnDef="newSerialNo">
              <mat-header-cell *matHeaderCellDef>{{"New Serial No." | translate | async}}</mat-header-cell>
              <mat-cell *matCellDef="let implement">
                <input id="newImplementSerialNo" type="text" placeholder="Serial#"
                  *ngIf="destinationequipmentOrInventory!=3" class="get-Input" [(ngModel)]="implement.newSerialNo" />
                <span *ngIf="destinationequipmentOrInventory==3">-</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="setupDate">
              <mat-header-cell *matHeaderCellDef>{{"Setup Date" | translate | async}}</mat-header-cell>
              <mat-cell *matCellDef="let implement" style="display:flex;">
                <input [matDatepicker]="picker" placeholder="Setup Date" [(ngModel)]="implement.setupDate"
                  class="get-Input" readonly="readonly">
                <span title="Click to select a date" class="input-icon" (click)="picker.open()"
                  *ngIf="destinationequipmentOrInventory!=3">
                  <i class="material-icons">date_range</i>
                </span>
                <mat-datepicker #picker></mat-datepicker>
              </mat-cell>

            </ng-container>

            <ng-container matColumnDef="implementHoursAtSetup">
              <mat-header-cell *matHeaderCellDef>{{"Implement Hours at Setup" | translate | async}}</mat-header-cell>
              <mat-cell *matCellDef="let implement">
                <input id="newImplementHours" type="text" placeholder="Implement Hours"
                  *ngIf="destinationequipmentOrInventory!=3" class="get-Input"
                  [(ngModel)]="implement.implementHoursAtSetup" />
              </mat-cell>

            </ng-container>

            <ng-container matColumnDef="equipmentSMUAtSetup">
              <mat-header-cell *matHeaderCellDef>{{"Equipment SMU at Setup" | translate | async}}</mat-header-cell>
              <mat-cell *matCellDef="let implement">
                <input id="equipmentSMU" type="text" placeholder="Equipment SMU" class="get-Input"
                  [(ngModel)]="implement.equipmentSMUAtSetup" *ngIf="destEquipment>=1" />
                <span *ngIf="destEquipment==0">N/A</span>
              </mat-cell>

            </ng-container>

            <ng-container matColumnDef="budget_hoursAtSetup">
              <mat-header-cell *matHeaderCellDef>{{"Budget Hours" | translate | async}}</mat-header-cell>
              <mat-cell *matCellDef="let implement">
                <div style="width:30px" *ngIf="destinationequipmentOrInventory!=3">
                  <input style="max-width: 150px;" id="budget_hours" type="text" placeholder="Budget Hours"
                    class="get-Input" [(ngModel)]="implement.budget_hours" />
                </div>

                <!-- <span *ngIf="destEquipment==0">N/A</span> -->
                <!-- <span *ngIf="destinationequipmentOrInventory==3">-</span> -->
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef>{{"Copied" | translate | async}}</mat-header-cell>
              <mat-cell *matCellDef="let implement">
                <i *ngIf="implement.status == 1" class="material-icons">check</i>
                <i *ngIf="implement.status == -1" class="material-icons">close</i>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Purchased_CostAtSetup">
              <mat-header-cell *matHeaderCellDef>{{"Purchased Cost" | translate | async}}</mat-header-cell>
              <mat-cell *matCellDef="let implement">
                <div style="width:15px" *ngIf="destinationequipmentOrInventory!=3">
                  <input style="max-width: 150px;" id="Purchased_Cost" type="text" placeholder="Purchased Cost"
                    class="get-Input" [(ngModel)]="implement.Purchased_Cost" />
                </div>

                <!-- <span *ngIf="destEquipment==0">N/A</span> -->
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
        </div>
      </ng-container>

      

      <ng-container *ngIf="selectedImplementId>0 && selectedImplementId!=null">

        <ng-container  *ngFor="let List of MultipleComponentsInfo">
          <span style="font-size: 18px;"><b>{{'Implement Serial' | translate | async}} : {{List.ImpSerial}}</b> </span>
        
        <table class="table table--striped table--full-width " id="table_detail" cellpadding=10>
          <thead>
            <tr>
              <th></th>
              <th>{{'Select Component' | translate | async}}</th>
              <th>{{'Component Name' | translate | async}}</th>
              <th>{{'Component Type' | translate | async}}</th>
              <th>{{'Part No' | translate | async}}</th>
              <th>{{'Budget Life' | translate | async}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let component of List.componnetList">
              <tr>
                <td (click)="component.expanded = !component.expanded"> 
                  <span  *ngIf="!component.expanded"  style="cursor: pointer;" class="material-icons"> add </span>
                  <span  *ngIf="component.expanded"  style="cursor: pointer;" class="material-icons"> remove </span>
                </td>
                <!-- <td>
                  <mat-checkbox [(ngModel)]="component.SelectedComp" (click)="CheckComponentSource(component,List.implementId)">
                  </mat-checkbox>
                </td> -->
                <td>
                  <mat-checkbox [(ngModel)]="component.SelectedComp" [disabled]="source === 'template' ? component.DisableCheckbox : false" 
                (click)=" !(source === 'template' && component.DisableCheckbox) && CheckComponentSource(component, List.implementId)">
                </mat-checkbox>
                </td>
                <td>{{component.ComponentName}}</td>
                <td>{{component.ComponentTypeName}}</td>
                <td>{{component.PartNo}}</td>
                <td>{{component.BudgetLife}}</td>

              </tr>
              <tr>
                <td colspan=6>
                  <ng-container *ngIf="component.expanded">
                    <table class="table table--striped table--full-width" style="margin-left: 2%;">
                      <thead>
                        <tr>
                          <th>{{'Select Obs. Point' | translate | async}}</th>
                          <th>{{'Observation Point' | translate | async}}</th>
                          <th>{{'OP Type' | translate | async}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let obs of component.ObsList">
                          <!-- <td>
                            <mat-checkbox [(ngModel)]="obs.SelectedObs" (click)="CheckObsPointSource(obs)">
                            </mat-checkbox>
                          </td> -->
                          <td>
                            <mat-checkbox [(ngModel)]="obs.SelectedObs" [disabled]="source === 'template' ? obs.DisableCheckbox : false"
                            (click)="!(source === 'template' && obs.DisableCheckbox) && CheckObsPointSource(obs)">
                          </mat-checkbox>
                        </td>
                          <td style="padding-left: 12px"> {{obs.ObsName}} </td>
                          <td> {{obs.ObsType}} </td>
                        </tr>
                      </tbody>
                    </table>

                  </ng-container>
                </td>
            </ng-container>
          </tbody>
        </table>
      </ng-container>
      </ng-container>
      <div class="button-container">
            <a class="button button--primary button-yes" [class.disabled]="source === 'template' && isCopyButtonDisabled()"
               (click)="!(source === 'template' && isCopyButtonDisabled()) && onConfirmClick()">
               <span class="button__text">{{"Copy Selected" | translate | async}}</span>
              </a>
        <!-- <a class="button button--primary button-yes" (click)="onConfirmClick()" >
          <span class="button__text">Copy Selected</span>
        </a> -->
      </div>
    </mat-card>
  </div>
</div>
